import type { ApiClient } from "./client";
import type { CrmEmailRetryResult, IntegrationDetail, IntegrationSummary } from "./types";

/** Integrations: domain operations the UI depends on. Implementations: HTTP (below) and mock (src/api/mock). */
export interface IntegrationsApi {
  list(): Promise<IntegrationSummary[]>;
  get(id: string): Promise<IntegrationDetail>;
  /** Send a failed or skipped CRM email again (the store's email may have been added since). */
  retryCrmEmail(id: string): Promise<CrmEmailRetryResult>;
}

export function createHttpIntegrationsApi(client: ApiClient): IntegrationsApi {
  return {
    list: async () => (await client.call<{ items: IntegrationSummary[] }>("listIntegrations")).items,
    get: (id) => client.call("getIntegration", { params: { id } }),
    retryCrmEmail: (id) => client.call("retryCrmEmail", { params: { id } }),
  };
}
